import { useRef, useContext, useState } from "react";
import "./NewWordForm.module.scss";
import AlreadyVotedContext from "../context/AlreadyVotedContext";
import ServerIsDownContext from "../context/ServerIsDownContext";
import { getVoteEndpoint } from "../api/endpoints";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";
function NewWordForm(props) {
  const wordInputRef = useRef();
  const { alreadyVoted, setAlreadyVoted } = useContext(AlreadyVotedContext);
  const { serverIsDown, setServerIsDown } = useContext(ServerIsDownContext);

  function submitHandler(event) {
    event.preventDefault();
    const enteredWord = wordInputRef.current.value;
    wordInputRef.current.value = "";
    const voteData = { word: enteredWord };
    const url = getVoteEndpoint();
    fetch(url, {
      method: "POST",
      body: JSON.stringify(voteData),
    })
      .then((response) => response.json())
      .then((data) => {
        const {message, voteAgain} = data;
        if (message !== "success") {
          toast.error(message);
        }else{
          toast.success(`You voted for ${enteredWord}`);
        }
        if (voteAgain !== undefined) {
          setAlreadyVoted(!voteAgain);
        }else{
          setAlreadyVoted(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setServerIsDown(true);
      });
    setAlreadyVoted(true);
  }
  return (
    <form onSubmit={submitHandler}>
      <input
        required
        type="text"
        id="word"
        ref={wordInputRef}
        placeholder={alreadyVoted ? "" : "Your word proposal"}
        maxLength={props.maxInputLength}
      />
      <button disabled={alreadyVoted}>
        {alreadyVoted ? "Voted " : "Vote "}
        {alreadyVoted ? (
          <FontAwesomeIcon icon={faCheck} />
        ) : (
          <FontAwesomeIcon icon={faPaperPlane} />
        )}
      </button>
    </form>
  );
}

export default NewWordForm;
